export default __webpack_public_path__ + "static/media/real.25edc7a3.png";